var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 237,
    viewBox: "0 0 280 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 226,
    cy: 226,
    r: 226,
    fill: "#3ED1D2"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 226.5,
    cy: 226.5,
    r: 191.5,
    fill: "#6DDADC"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 226,
    cy: 226,
    r: 153,
    fill: "#3ED1D2"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 226.5,
    cy: 226.5,
    r: 122.5,
    fill: "#3ED1D2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBg);
export default __webpack_public_path__ + "static/media/circle_bg.c4f8178930852a7836d20a97ad7733bf.svg";
export { ForwardRef as ReactComponent };